import {
	ADBannerListAdapter,
	getADBannersAdapter,
} from '@api/FW/adapters/ADbanner/getADBanners.adapter';
import { getQueryParams, httpApi } from '@api/FW/http.api';
import { IADBanner } from '@components/shared/ADBanner/types';

/**
 * Fetch all the users quick actions.
 */
export const getADBanner = (): Promise<IADBanner> => {
	return httpApi
		.get(`QuickAction/BANNER/`, {
			timeout: 1000,
			params: getQueryParams(),
		})
		.then(({ data }) => data)
		.catch((err) => {
			throw err;
		});
};

/**
 * Fetch the ordered list of home page banners.
 */
export const getADBanners = (): Promise<IADBanner[]> => {
	return httpApi
		.get<ADBannerListAdapter>(`QuickAction/BANNER_ARRAY/`, {
			// The list endpoint measures ~425ms, so BANNER's inherited 1s budget left no
			// headroom — a slow round trip dropped the banner and raised a timeout toast.
			timeout: 10000,
			params: getQueryParams(),
		})
		.then(({ data }) => getADBannersAdapter(data))
		.catch((err) => {
			throw err;
		});
};
